import { useMemo } from 'react';

import { Sources } from 'components/insights/constants';
import useInsightsAnalytics, { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import { getBusinessDevelopmentAnalyticsFilters, useBusinessDevelopmentStore } from 'stores/businessDevelopmentStore';

export type BusinessDevelopmentQueryParams = InsightsQueryParams;

type Options = {
  queryKey?: string;
  enabled?: boolean;
};

export default function useBusinessDevelopmentAnalytics(
  queryParams: BusinessDevelopmentQueryParams,
  { queryKey = 'businessDevelopmentAnalytics', enabled = true }: Options = {}
) {
  const filters = useBusinessDevelopmentStore((state) => getBusinessDevelopmentAnalyticsFilters(state));

  const resolvedFilters = useMemo(() => {
    if (!filters) return null;

    if (queryParams.source === Sources.INSIGHTS_REFERRALS) {
      // The referrals source uses different filter key names than care_transitions/discharges:
      //   predecessorGroupType → sendingGroupType
      //   groupType → receivingGroupType
      //   providerClient → receivingClient
      //   group → receivingGroup
      const { predecessorGroupType, groupType, providerClient, group, ...rest } = filters;
      return {
        ...rest,
        sendingGroupType: predecessorGroupType,
        receivingGroupType: groupType,
        receivingClient: providerClient,
        receivingGroup: group,
      };
    }

    return filters;
  }, [filters, queryParams.source]);

  return useInsightsAnalytics(queryParams, resolvedFilters, { queryKey, enabled });
}
